import CmnBtnContainer from "../layout/components/CmnBtnContainer";
import Features from "../layout/components/Features";

const Solutions = () => {
  return (
    <>
        <div style={{height : "100vh"}} className="cmn-page-container">
            <div style={{height : "100%"}} className="page-content-wrapper">
                <div className="content">
                    <p>We Bring Solution for your Business</p>
                    <CmnBtnContainer/>
                </div>
                <div className="cmn-img-container">
                    <div className="cmn-img-wrapper">
                        <img src="/images/temp1.png" alt="solution home page" width="fit-content" height="100%" />
                    </div>
                    <div id="top-right-rect"></div>
                    <div id="bottom-left-rect1" className="rect"></div>
                    <div id="bottom-left-rect2" className="rect"></div>
                </div>
            </div>
            <div id="borders-container">
                <div style={{width : "75%", bottom: "-40%", position : "absolute"}} className="left-box box-outline"></div>
                <div style={{width : "78%", bottom: "-50%", position : "absolute"}} className="left-box box-outline"></div>
                <div style={{width : "81%", bottom: "-60%", position : "absolute"}} className="left-box box-outline"></div>
                <div style={{width : "22%", bottom: "-30%", position : "absolute"}} className="right-box box-outline"></div>
                <div style={{width : "24%", bottom: "-40%", position : "absolute"}} className="right-box box-outline"></div>
                <div style={{width : "26%", bottom: "-50%", position : "absolute"}} className="right-box box-outline"></div>
            </div>
        </div>
        <Features/>
    </>
  )
}

export default Solutions;